import React from 'react';
import { connect } from 'react-redux';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import ConfigDiff from '@/components/Cluster/ConfigDiff';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

/**
 * @param {Object} props
 * @returns
 */
function Summary({ overview, loading }) {
  const items = [
    {
      title: 'Brokers',
      info: <CountUp end={overview.activeBrokerCount} duration={0.4} />,
      unit: overview.version,
      icon: 'other2',
    },
    {
      title: 'Controller',
      info: overview.controllerBrokerId,
      unit: overview.controllerBrokerHost,
      icon: 'other3',
    },
    {
      title: 'Partitions',
      info: <CountUp end={overview.totalTopicPartitions || 0} duration={0.4} />,
      icon: 'other4',
      unit: '个',
    },
    <ConfigDiff
      key={1}
      title='Similar Config'
      icon='other5'
      correct={overview.similarConfig}
      data={overview.similarConfigVOList || []}
    />,
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect((state) => ({
  overview: state.kafkaBroker.overview,
  loading: state.kafkaBroker.loading,
}))(Summary);
